import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// Newly added code starts
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
// Newly added code ends
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: ShopCentroFlyoutStyles;
}

export interface ShopCentroFlyoutStyles {
    widgetGridContainer?: GridContainerProps;
    logInGridItem?: GridItemProps;
    createAccountGridItem?: GridItemProps;
    parentGridWrapper?: InjectableCss;
}

export const shopCentroFlyoutStyles: ShopCentroFlyoutStyles = {
    parentGridWrapper: {
        css: css`
            position: relative;
        `,
    },
    widgetGridContainer: {
        css: css`
            position: relative;
            display: none;
            width: 232px;
            min-height:181px;
            padding: 24px 16px;
            border: 1px solid ${COLORS.border.light};
            box-shadow: 0px 8px 16px rgba(38, 37, 37, 0.24);
            background-color: ${COLORS.white};

            &.open-my-account-flyout {
                display: block;
                position: absolute;
                right: 1%;
                z-index: 1;
                margin-top: 7px;
            }

            &:before, &:after {
                content: '';
                display: block;
                position: absolute;
                bottom: 100%;
                width: 0;
                height: 0;
              }
              &:before {
                right: 19px;
                border: 11px solid transparent;
                border-bottom-color: ${COLORS.border.light};
              }
              &:after {
                right: 20px;
                border: 10px solid transparent;
                border-bottom-color: ${COLORS.white};
              }
        `,
    },
    logInGridItem: {
        width: 12,
        css: css`
            display: block;
        `,
    },
    createAccountGridItem: {
        width: 12,
        css: css`
            padding: 0px 16px;
            div[class^=GridItemStyle]{
                padding: 0px !important;
            }
            button {
                background: none;
                border: none;
                color: #8F0446;
                height: 32px;
                &:hover {
                    background: none;
                    border: none;
                }
            }
        `,
    },
};

const MyAccountFlyout: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(shopCentroFlyoutStyles, extendedStyles));
    return (
        <StyledWrapper {...styles.parentGridWrapper}>
            <GridContainer {...styles.widgetGridContainer} id="my-account-flyout">
            <GridItem {...styles.logInGridItem}>
                <StyledWrapper>
                    <Zone zoneName="LogIn" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.createAccountGridItem}>
                <Zone zoneName="CreateAccount" contentId={id} />
            </GridItem>
        </GridContainer>
        </StyledWrapper>
        
    );
};

const myAccountFlyout: WidgetModule = {
    component: MyAccountFlyout,
    definition: {
        group: "Header",
    },
};

export default myAccountFlyout;
